import {Space} from "antd";
import {useCreateLiveEventContext} from "../../context/create-live-event";
import {CreateLiveEventBasicFormStep} from "../basic-form";
import {CreateLiveEventCheckoutFormStep} from "../checkout-form";
import {CreateLiveEventFormStepsMobile} from "../create-live-event-steps";
import {FormWrapper} from "../../../../../components/form-wrapper";
import {CreateLiveEventCohostStep} from "../co-host";
import {StyledHideStepOnDesktop} from "../../../../../components/offering-form/general/steps/styles";
import {CreateLiveEventCoverImagesUploadStep} from "../cover-images-upload";
import {CreateLiveEventAutomationsStep} from "../automations";
import {DraftResumeBanner} from "../../../../../components/offering-form/general/draft-resume-banner";
import {useDraftResumeBanner} from "../../../../../utils/offering-create-draft";

export function CreateLiveEventMultiStepForm() {
  const {
    dispatch,
    wasDraftRestored,
    state: {currentCreateLiveEventStep},
  } = useCreateLiveEventContext();
  const {formKey, showBanner, handleStartFresh} = useDraftResumeBanner(
    wasDraftRestored,
    dispatch
  );

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {showBanner ? <DraftResumeBanner onStartFresh={handleStartFresh} /> : null}
      <StyledHideStepOnDesktop>
        <CreateLiveEventFormStepsMobile />
      </StyledHideStepOnDesktop>
      <FormWrapper key={formKey}>
        {currentCreateLiveEventStep === "basicForm" ? (
          <CreateLiveEventBasicFormStep />
        ) : currentCreateLiveEventStep === "checkoutForm" ? (
          <CreateLiveEventCheckoutFormStep />
        ) : currentCreateLiveEventStep === "coverImagesUpload" ? (
          <CreateLiveEventCoverImagesUploadStep />
        ) : currentCreateLiveEventStep === "cohost" ? (
          <CreateLiveEventCohostStep />
        ) : currentCreateLiveEventStep === "automations" ? (
          <CreateLiveEventAutomationsStep />
        ) : null}
      </FormWrapper>
    </Space>
  );
}
